import { fork, put, call, take } from "redux-saga/effects";

// Actions
import * as actionsCreator from "../reducer";
import { showMessage } from 'reducers/messages';

// Type
import { ActionType, ActionTypeDelete } from "../type";

// Sagas
import { bioSearchSagaStart } from "./saga-bio-search";
import { searchTextSagaStart } from "./saga-search-text";
import { structureSearchSagaStart } from "./saga-structure-search";
import { searchTextListByIdsSagaStart } from "./saga-by-list-of-ids";

// Store
import { RootState } from "store";

export const search = (store: RootState) => store.search;


// Start Sagas
export function* searchSagaStart(api: any, action: any) {
  yield fork(historyListWatcher, api, action);
  yield fork(bioSearchSagaStart, api, action);
  yield fork(searchTextSagaStart, api, action);
  yield fork(structureSearchSagaStart, api, action);
  yield fork(structureSearchDeleteItemWatcher, api, action);

  yield fork(searchTextListByIdsSagaStart, api, action);

  yield fork(downloadSDFWatcher, api, action);
}

/**
 * Download sdf by type on search by list of id Search Watcher
 *
 * @param {function} api - api object
 * @param {object} action - action from dispatch
 * @returns
 */
export function* downloadSDFWatcher(api: any, action: any): Generator<any, void, any> {
  while (true) {
    try {
      const actions: {
        type?: string,
        payload?: {
          ids: string[],
          sdfVersion: string,
        },
      } = yield take(actionsCreator.downloadSDF.type);

      const ids = actions?.payload?.ids;
      const sdfVersion = actions?.payload?.sdfVersion;

      const res = yield call(api.request, 'downloadSDFAnyIdsSdf', ids, sdfVersion);

      if (!res.ok) {
        yield put(actionsCreator.downloadSDFError());
      } else {
        let filenameMatch = '';
        let filename = `untitled.sdf`;

        const contentDisposition = res?.headers['content-disposition'] || '';
        if (contentDisposition) {
          filenameMatch = contentDisposition.match(/filename[^;=\n]*=(["'])?([^"\n]*)\1?/);
          if (filenameMatch && filenameMatch.length > 2) {
            filename = filenameMatch[2];
          }
        }

        const href = window.URL.createObjectURL(res.data);
        const link = document.createElement('a');

        link.href = href;
        link.setAttribute('download', filename); //or any other extension

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);

        yield put(actionsCreator.downloadSDFSuccess());
        yield put(showMessage({
          type: "info",
          text: "The file was downloaded successfully"
        }))
      }
    } catch (e) {
      console.log("CATCH ERROR in downloadSDFWatcher: ", e);
    }
  }
}

/**
 * Structure list delete item Search Watcher
 *
 * @param {function} api - api object
 * @param {object} action - action from dispatch
 * @returns
 */
export function* structureSearchDeleteItemWatcher(api: any, action: any) {
  while (true) {
    try {
      const actions: ActionTypeDelete = yield take(
        actionsCreator.deleteItemStructureHistory.type
      );

      const listStructureSearch = JSON.parse(
        localStorage.getItem("structureList") || "[]"
      );
      const result = listStructureSearch.filter(
        (item: string) => item !== actions?.payload
      );

      localStorage.setItem("structureList", JSON.stringify(result));
      yield put(actionsCreator.updateHistoryStructureSearch(result));
    } catch (e) {
      console.log("CATCH ERROR in structureSearchDeleteItemWatcher: ", e);
    }
  }
}

/**
 * History list Watcher
 *
 * @param {function} api - api object
 * @param {object} action - action from dispatch
 * @returns
 */
export function* historyListWatcher(api: any, action: any): Generator<any, void, any> {
  while (true) {
    try {
      const actions: ActionType = yield take(
        actionsCreator.historyList.type
      );

      let result = [];
      const maxLngtItem = 9;
      const payload = actions?.payload?.data || "";
      const localStoreKey = actions?.payload?.localStoreKey || "";

      if (payload) {
        const listStructureSearch = JSON.parse(localStorage.getItem(localStoreKey) || "[]");

        if (
          listStructureSearch &&
          listStructureSearch.length
        ) {
          const found = listStructureSearch.some((item: any) => item === payload);

          if (found) {
            listStructureSearch.filter((item: any) => item !== payload);
            result = listStructureSearch;
          } else {
            if (listStructureSearch.length >= maxLngtItem) {
              listStructureSearch.pop();
              result = [payload, ...listStructureSearch];
            } else {
              result = [payload, ...listStructureSearch];
            }
          }

          localStorage.setItem(localStoreKey, JSON.stringify(result));
          yield put(actionsCreator.historyList({
            data: result,
            storeName: actions?.payload?.storeName,
            localStoreKey: actions?.payload?.localStoreKey
          }));
        } else {
          yield put(actionsCreator.historyList({
            data: [payload],
            storeName: actions?.payload?.storeName,
            localStoreKey: actions?.payload?.localStoreKey
          }));
          localStorage.setItem(localStoreKey, JSON.stringify([payload]));
        }
      }
    } catch (e) {
      console.log("CATCH ERROR historyListWatcher: ", e);
    }
  }
}
